import { FC, ReactNode } from 'react';

export const Footer: FC<IFooterComponent> = ({ children }) => {
  return <>{children}</>;
};

interface IFooterComponent {
  children: ReactNode;
}
